import { IDbSchemaState } from "./reducer";

const initialState: IDbSchemaState = {
  isFetchingTablesForClient: false,
  allTables: [],
  errors: [],
};

export default initialState;
